import { AutogenModelAuthorizationStatus, AutogenRowAuthorizationStatus } from "./autogen/AutogenModelAuthorizationStatus";

export class ModelAuthorizationStatus extends AutogenModelAuthorizationStatus<RowAuthorizationStatus> {
	constructor() {
		super(RowAuthorizationStatus);
	}
}

export class RowAuthorizationStatus extends AutogenRowAuthorizationStatus {
}